import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import isEmpty from 'lodash.isempty';
import { NUMBER_2 } from '~shared/constants';

@Component({
  selector: 'app-storefront-seller-avatar',
  templateUrl: './seller-avatar.component.html',
  styleUrls: ['./seller-avatar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SellerAvatarComponent implements OnChanges {
  @Input() imageUrl: string;
  @Input() fullName: string;
  @Input() lettersCount = NUMBER_2;
  @Input() mode: 'small' | 'default' | 'medium' = 'default';
  abbreviation: string;
  isImageExist = false;

  private static transformFullName(fullName = '', lettersCount: number): string {
    const nameSlices = (fullName && fullName.split(' ')) || [];

    return nameSlices && (nameSlices.length < NUMBER_2)
      ? fullName.substring(0, lettersCount).toUpperCase()
      : SellerAvatarComponent.pickLetters(nameSlices).substring(0, lettersCount).toUpperCase();
  }

  private static pickLetters(slices: string[]): string {
    return slices && slices.length ? slices.reduce((acc, slice) => acc + slice.charAt(0), '') : '';
  }

  onError() {
    this.isImageExist = false;
  }

  ngOnChanges() {
    this.abbreviation = SellerAvatarComponent.transformFullName(this.fullName, this.lettersCount);

    this.isImageExist = !isEmpty(this.imageUrl);
  }
}
